import { useState } from 'react';

export const eraseCookie = (key: string) => {
	document.cookie = `${key}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
}

export const setCookie = (key: string, value: string, hours?: number) => {
	let expires = '';
	if (hours) {
		const date = new Date();
		date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
		expires = `; expires=${date.toUTCString()}`;
	}
	document.cookie = `${key}=${value}${expires}; path=/`;
}

export const getCookie = (key: string) => {
	const cookie = document.cookie.match(
		'(^|[^;]+)\\s*' + key + '\\s*=\\s*([^;]+)',
	);
	if (cookie) {
		const tasty = cookie.pop();
		return tasty === 'null' ? null : tasty;
	}
	return null;
};

